@let hasFooter = ui.getFooterStatus() | async;
@let embedded = appStateService.embedded();
@if(hasFooter != null) {
  <router-outlet></router-outlet>
  <cr-loader></cr-loader>
  @if (hasFooter) {
    <app-footer></app-footer>
  }
  @if (!embedded) {
    <app-dialog-ongoing-analysis></app-dialog-ongoing-analysis>
  }
  <app-home-button></app-home-button>
}
<app-dialog-error></app-dialog-error>
<app-dialog-cookies></app-dialog-cookies>
